<template>
  <a-layout class="apply-online">
    <!-- head -->
      <!-- <page-header :breadcrumb="breadcrumb"></page-header> -->
      <slot>
        <!-- 表格 -->
        <!-- <a-col :span="4"></a-col> -->
        <a-col :span="20" :offset="2" style="margin-bottom:72px;">
          <a-tabs defaultActiveKey="1" @change="callback">
            <a-tab-pane tab="报修申请" key="1">
              <span class="bxxzbuttom" @click="xzshowModal(true)">
                <img :src="warningPic" />报修须知
              </span>
              <!-- <a-col :span="4"></a-col> -->
              <a-col :span="20" :offset="2">
                <a-form :form="form" @submit="submitAll">
                  <a-row style="padding-left:3.5%">
                    <a-col :span="10" style="padding-right: 20px;">
                      <a-form-item label="报修地点" :labelCol="{span: 8}" :wrapperCol="{span: 16}">
                        <!-- 校区 -->
                        <a-select
                          v-decorator="['xqdm',
                            {rules: [{ required: true, message: '请选择校区!' }]}
                          ]"
                          placeholder="请选择"
                          @change="handleSchoolChange"
                        >
                          <a-select-option
                            v-for="schoolData in schoolData"
                            :key="schoolData.value"
                          >{{schoolData.label}}</a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                    <!-- 宿舍楼 -->
                    <a-col v-if="buildData.length > 0" :span="7" style="padding-right: 20px;">
                      <a-form-item>
                        <a-select
                          v-decorator="['lyId',
                            {rules: [{ required: true, message: '请选择宿舍楼!' }]}
                          ]"
                          placeholder="请选择"
                          @change="handleBuildChange"
                        >
                          <a-select-option
                            v-for="buildData in buildData"
                            :key="buildData.id"
                          >{{buildData.name}}</a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                    <!-- 房间号 -->
                    <a-col
                      v-if="buildData.length > 0 && roomData.length>0"
                      :span="7"
                      style="padding-right: 20px;"
                    >
                      <a-form-item>
                        <a-select
                          v-decorator="['qyfjh',
                            {rules: [{ required: true, message: '请选择房间号!' }]}
                          ]"
                          placeholder="请选择"
                        >
                          <a-select-option
                            v-for="roomData in roomData"
                            :key="roomData.id"
                          >{{roomData.name}}</a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                  </a-row>
                  <a-form-item
                    label="详细地址"
                    :labelCol="{span: 4}"
                    :wrapperCol="{span: 20}"
                    style="padding-right: 20px;"
                  >
                    <!-- { pattern: /^[\s\S]{2,50}$/, message: '请输入2-50位！' } -->
                    <a-input
                      v-decorator="[
                          'xxdz',
                          {
                            rules: [
                              { required: true, message: '请输入详细地址！' }
                            ]
                          }
                        ]"
                      autocomplete="off"
                      placeholder="请输入详细地址"
                      maxlength="50"
                    />
                  </a-form-item>
                  <a-form-item
                    label="账号"
                    :labelCol="{span: 4}"
                    :wrapperCol="{span: 20}"
                    style="padding-right: 20px;"
                  >
                    <a-input
                      v-decorator="[
                          'code',
                          {
                            rules: [
                              { required: true, message: '请输入账号！' }
                            ]
                          }
                        ]"
                      autocomplete="off"
                      placeholder="请输入学号或者工号"
                      maxlength="11"
                      style="width:150px"
                    />
                  </a-form-item>
                  <a-form-item
                    label="报修人姓名"
                    :labelCol="{span: 4}"
                    :wrapperCol="{span: 20}"
                    style="padding-right: 20px;"
                  >
                    <a-input
                      v-decorator="[
                          'xm',
                          {
                            rules: [
                              { required: true, message: '请输入姓名！' }
                            ]
                          }
                        ]"
                      autocomplete="off"
                      placeholder="请输入姓名"
                      maxlength="11"
                      style="width:150px"
                    />
                  </a-form-item>
                  <a-form-item
                    label="手机号"
                    :labelCol="{span: 4}"
                    :wrapperCol="{span: 20}"
                    style="padding-right: 20px;"
                  >
                    <a-input
                      v-decorator="[
                          'sjh',
                          {
                            rules: [
                              { required: true, message: '请输入手机号！' },
                              { pattern: /^1\d{10}$/, message: '请输入正确的格式！' }
                            ]
                          }
                        ]"
                      autocomplete="off"
                      placeholder="请输入手机号"
                      maxlength="11"
                    />
                  </a-form-item>
                  <a-form-item label="报修类型" :labelCol="{span: 4}" :wrapperCol="{span: 20}">
                    <!-- 报修类型 -->
                    <a-col :span="8" style="padding-right: 20px;">
                      <a-select
                        v-decorator="['bxlx',
                          {rules: [{ required: true, message: '请至少选择一级报修类型!' }]}
                        ]"
                        placeholder="请选择"
                        @change="handletypeChange"
                      >
                        <a-select-option
                          v-for="typeData in typeData"
                          :key="typeData.id"
                        >{{typeData.mc}}</a-select-option>
                      </a-select>
                    </a-col>
                    <a-col v-if="typetwoData.length > 0" :span="8" style="padding-right: 20px;">
                      <a-select
                        v-model="typetwoDatamod"
                        placeholder="请选择"
                        @change="handletypetwoChange"
                      >
                        <a-select-option
                          v-for="typetwoData in typetwoData"
                          :key="typetwoData.id"
                        >{{typetwoData.mc}}</a-select-option>
                      </a-select>
                    </a-col>
                    <a-col
                      v-if="typetwoData.length > 0 && typethirData.length>0"
                      :span="8"
                      style="padding-right: 20px;"
                    >
                      <a-select v-model="typethirDatamod" placeholder="请选择">
                        <a-select-option
                          v-for="typethirData in typethirData"
                          :key="typethirData.id"
                        >{{typethirData.mc}}</a-select-option>
                      </a-select>
                    </a-col>
                  </a-form-item>
                  <a-form-item
                    label="故障描述"
                    :labelCol="{span: 4}"
                    :wrapperCol="{span: 20}"
                    style="padding-right: 20px;"
                  >
                    <!-- { pattern: /^[\s\S]{2,10}$/, message: '请输入2-10位！' } -->
                    <a-textarea
                      :rows="3"
                      v-decorator="[
                          'gzms',
                          {
                            rules: [
                              { required: true, message: '请输入故障描述！' }
                            ]
                          }
                        ]"
                      placeholder="请输入故障描述"
                      maxlength="200"
                    />
                  </a-form-item>
                  <a-form-item
                    class="updatimg"
                    :labelCol="{span: 4}"
                    :wrapperCol="{span: 20}"
                    style="padding-right: 20px;"
                  >
                    <div slot="label">上传故障图片（最多上传10张）</div>
                    <upload-picture
                      action="/api/file/upload.do"
                      :seenote="enableedit"
                      v-decorator="['imgUrl']"
                    />
                    <!-- {rules:[{ required: true, message: '请上传图片！' }]} -->
                  </a-form-item>
                  <!-- <a-form-item :labelCol="{span: 4}" :wrapperCol="{span: 20}">
                    <div slot="label">维修时间特殊要求（可不填）</div>
                    <a-col :span="8" style="padding-right: 20px;">
                      <a-select allowClear v-model="timestartmod">
                        <a-select-option
                          v-for="timestart in timestart"
                          :key="timestart.value"
                        >{{timestart.label}}</a-select-option>
                      </a-select>
                    </a-col>
                    <a-col :span="8" style="padding-right: 20px;">
                      <a-select allowClear v-model="timeendmod">
                        <a-select-option
                          v-for="timeend in timeend"
                          :key="timeend.value"
                        >{{timeend.label}}</a-select-option>
                      </a-select>
                    </a-col>
                  </a-form-item> -->
                  <a-form-item style="text-align: center;">
                    <a-button type="primary" html-type="submit">提交申请</a-button>
                  </a-form-item>
                </a-form>
              </a-col>
              <!-- <a-col :span="4"></a-col> -->
            </a-tab-pane>
            <!-- <a-tab-pane tab="我的报修" key="2" forceRender></a-tab-pane> -->
          </a-tabs>
        </a-col>
        <!-- 报修须知 -->
        <a-modal
          destroyOnClose
          :maskClosable="false"
          :title="bxtitle"
          v-model="shoudkonw"
          :footer="null"
        >
          <div class="xzcontent"></div>
          <div class="mydiyfooter">
            <a-button @click="xzhandleSubmit" type="primary">我知道了</a-button>
          </div>
        </a-modal>
      </slot>
    <!-- footer -->
    <a-layout-footer style="padding: 0px">
      <global-footer />
    </a-layout-footer>
  </a-layout>
</template>

<script>
import GlobalFooter from '../../layouts/GlobalFooter'
import UploadPicture from '../../components/upload/UploadPicture'
import warningPic from '../../assets/png/warningPic.png'
import './Apply.less'
// const statusMap = ['启用', '停用'] // 0-启用、1-启用
export default {
  name: 'Apply',
  components: {
    GlobalFooter,
    UploadPicture
  },
  computed: {
    linkList () {
      return this.$store.state.setting.footerLinks
    }
  },
  data () {
    return {
      bxtype: this.$route.query.bxtype,
      warningPic,
      breadcrumb: [],
      form: this.$form.createForm(this),
      xzdataSource: [],
      selectedRows: [],
      current: {},
      cityOptions: [],
      bxtitle: '报修须知',
      username: '',
      enableedit: false,
      // 下拉
      schoolData: [],
      buildData: [],
      roomData: [],
      typeData: [],
      typetwoData: [],
      typethirData: [],
      timestart: [],
      timeend: [],
      typetwoDatamod: undefined,
      typethirDatamod: undefined,
      timestartmod: '',
      timeendmod: '',
      // 上传
      previewVisible: false,
      previewImage: '',
      fileList: [],
      // 须知
      shoudkonw: true,
      ny: '',
      submittype: true
    }
  },
  mounted () {
    // 获取校区
    this.schoolList()
    // 获取报修类型
    this.typeList()
    // 特殊类型
    this.specailtime()
    // 报修须知内容
    this.xzcontent()
    this.getBreadcrumb()
  },
  methods: {
    // 获取默认校区
    // getMrSchool () {
    //   this.$axios.post('/api/bxjl/getXqByXh.do').then(res => {
    //     if (res.data.data) {
    //       this.form.setFieldsValue({ xqdm: res.data.data.value })
    //       this.handleSchoolChange(res.data.data.value)
    //     }
    //   })
    // },
    getBreadcrumb () {
      this.breadcrumb = this.$route.matched
    },
    schoolList () {
      let self = this
      this.$axios.post('/api/dict/getXqInfo.do').then(res => {
        this.schoolData = res.data.data || []
        this.$nextTick(function () {
        })
      })
    },
    // 学校change
    handleSchoolChange (value) {
      this.form.setFieldsValue({ lyId: undefined, qyfjh: undefined })
      this.buildList(value)
    },
    buildList (id) {
      this.$axios.post('/api/bxjl/getBxdd.do', { xqdm: id, activeFlag: '1' }).then(res => {
        this.buildData = res.data.data || []
      })
    },
    // 楼宇change
    handleBuildChange (value) {
      this.form.setFieldsValue({ qyfjh: undefined })
      this.roomList(value)
    },
    roomList (name) {
      this.$axios.post('/api/bxjl/getBxdd.do', { lyId: name, activeFlag: '1' }).then(res => {
        this.roomData = res.data.data || []
      })
    },
    typeList () {
      this.$axios.post('/api/bxjl/getBxlx.do', { cj: 1, activeFlag: '1' }).then(res => {
        this.typeData = res.data.data || []
      })
    },
    // 报修类型
    handletypeChange (value) {
      this.typetwoList(value)
      this.typetwoDatamod = undefined
      this.typethirDatamod = undefined
    },
    typetwoList (id) {
      this.$axios.post('/api/bxjl/getBxlx.do', { cj: 2, pId: id, activeFlag: '1' }).then(res => {
        this.typetwoData = res.data.data || []
      })
    },
    // 报修类型two
    handletypetwoChange (value) {
      this.typethirList(value)
      this.typethirDatamod = undefined
    },
    typethirList (id) {
      this.$axios.post('/api/bxjl/getBxlx.do', { cj: 3, pId: id, activeFlag: '1' }).then(res => {
        this.typethirData = res.data.data || []
      })
    },
    // 特殊时间
    specailtime () {
      this.$axios
        .post('/api/dict/getDictListByTypeId.do', {
          typeId: '8aa867c76a2918b0016a2918ccbe0000'
        })
        .then(res => {
          this.timestart = res.data.data || []
          this.timeend = res.data.data || []
        })
    },
    // 获取学区下拉
    schoolArea () {
      this.$axios.post('/api/dict/getXqInfo.do').then(res => {
        this.cityOptions = res.data.data || []
      })
    },
    // 提交报修订单
    submitAll (e) {
      if (!this.submittype) {
        return false
      }
      this.submittype = false
      e.preventDefault()
      let $this = this
      this.form.validateFields((err, values) => {
        if (!err) {
          // 处理编辑时添加ID字段
          if (JSON.stringify($this.current) !== '{}') {
            values.id = $this.current.id
          }
          let ids = []
          if (values.imgUrl) {
            ids = values.imgUrl.map(item => item.id)
          }
          values.tpId = ids.join(',')
          if ($this.typethirDatamod) {
            values.bxlx = $this.typethirDatamod
          } else if ($this.typetwoDatamod) {
            values.bxlx = $this.typetwoDatamod
          }
          values.kssj = $this.timestartmod
          values.jssj = $this.timeendmod
          values.type = '1'
          if ($this.bxtype && $this.bxtype == '2') {
            values.type = '2'
          }
          // 接口请求
          this.submitAllAjax(values)
        }
      })
    },
    submitAllAjax (params) {
      params.sfswjxy = '1'
      this.$axios.post('/api/bxgl/saveOrUpdateBxd.do', params).then(res => {
        this.submittype = true
        if (res.flag) {
          if (res.code === 'A_90000') {
            this.$message.error(res.msg)
          } else {
            this.$message.success('提交申请成功！')
            setTimeout(() => {
              let params = {}
              if (this.bxtype == '2') {
                params = {
                  bxtype: 2
                }
              }
              this.submittype = true
              window.location.reload()
            }, 1000)
          }
        }
      })
    },
    /**
     * 获取请求列表参数
     * @param { Object } customParam 自定义处理
     * @return { Object } 请求列表参数
     */
    getFetchParams (customParam) {
      const { pageNum, isRemove } = customParam || {}
      let params = {
        // ...this.searchForm.getFieldsValue(),
        ...this.PAGINATION,
        ...customParam
      }
      if (pageNum && params.pageNum) {
        params.pageNum = pageNum
      } else {
        params.pageNum = 1
        params.pageSize = 10
      }
      if (isRemove && params.pageNum && this.dataSource.length % 10 === 1) {
        params.pageNum = params.pageNum > 2 ? params.pageNum - 1 : 1
      }
      // // 用户类型
      // params.type = '0'
      return params
    },

    // 报修须知内容
    xzcontent () {
      this.$axios.post('/api/bxjl/getBxxz.do').then(res => {
        if (res.flag) {
          if (res.data.data !== null) {
            this.ny = res.data.data.ny
            if (res.data.data.ny === '') {
              this.ny = '尚未编辑须知内容'
            }
          }
        }
        this.$nextTick(() => {
          setTimeout(() => {
            $('.xzcontent').html(this.ny)
          }, 200);
        })
      })
    },
    // 报修须知弹窗
    xzshowModal (visible) {
      this.shoudkonw = !!visible
      //   this.xzform.setFieldsValue()
      this.$nextTick(() => {
        $('.xzcontent').html(this.ny)
      })
    },
    // 顶部tab
    callback (key) {
      // 我的报修
      let params = {}
      if (this.bxtype === '2') {
        params = {
          bxtype: this.bxtype
        }
      }
      this.$router.push({ path: '/myApply', query: params })
    },
    // 导出
    exportExe () {
      var url = ''
      window.location.herf = url
    },
    // 是否启用请求
    enableAjax (params) {
      this.$axios.post('/api/user/updateUserStatus', params).then(res => {
        this.$message.success(
          `成功${params.status === 1 ? ' 停用' : '启用'}！`
        )
        // 重新获取列表数据
        this.fetchList(this.getFetchParams())
      })
    },
    xzhandleSubmit () {
      this.shoudkonw = false
    }
  }
}
</script>
<style lang="less">
.apply-online {
  .updatimg .ant-form-item-label div {
    margin-top: 10px;
  }
}
</style>
